<div class="career_detail_page">
  <div class="detail_content" *ngIf="job">
    <div class="heading d-flex">
      <div class="d-flex left">
        <lucide-icon name="ArrowLeft" (click)="goBack()" class="arrow"></lucide-icon>
        <h2>{{job.title }}</h2>
        <span [ngClass]="getRoleClass(job.category)" class="role">{{ job.category }}</span>
        <span class="location">
          <span class="icon_location">
            <lucide-icon name="MapPin" class="icon_location"></lucide-icon>
          </span>
          {{ job.location }}
        </span>
      </div>
      <!-- <button class="apply_btn" mat-button (click)="openModal()">{{ job.buttonText }}</button>
      <button class="apply_btn" mat-button>
        <a (click)="pushCareerApplyEvent()" href="mailto:Suraj.Mishra02@motherson.com">Apply</a>
      </button>-->
    </div>

    <div class="container">
      <div class="detail">
        <!-- Job Summary -->
        <div class="summary">
          <h3>Summary</h3>
          <p>{{ job.summary }}</p>
        </div>

        <!-- Experience -->
        <div class="experience">
          <h3>Experience</h3>
          <p>{{ job.experience }}</p>
        </div>

        <!-- Responsibilities -->
        <div class="Responsibility">
          <h3>Responsibilities</h3>
          <ul>
            <li *ngFor="let responsibility of job.description">{{ responsibility }}</li>
          </ul>
        </div>

        <!-- Responsibilities -->
        <div class="Responsibility" *ngIf="job.keySkills?.length">
          <h3>Key Skills</h3>
          <ul>
            <li *ngFor="let skills of job.keySkills">{{ skills }}</li>
          </ul>
        </div>

        <!-- Qualifications -->
        <div class="qualification">
          <h3>Qualifications</h3>
          <p>{{ job.education }}</p>
        </div>

        <!-- What we offer -->
        <!-- <div class="what_we_offer">
          <h3>{{ job.offers.heading }}</h3>
          <ul>
            <li *ngFor="let offer of job.offers.items">{{ offer }}</li>
          </ul>
        </div> -->
      </div>
      <a (click)="pushCareerApplyEvent()" href="mailto:hiring.unibuild@motherson.com"><button class="apply_btn custom-apply-btn" mat-button>Apply</button></a>
    </div>
  </div>

  <!-- Modal box -->
  <div class="modal_box" *ngIf="isModalOpen">
    <div class="modal_content">
      <div class="modal_heading d-flex">
        <h2>Job Application</h2>

        <span class="close"> <lucide-icon (click)="closeModal()" name="X" class="icon"></lucide-icon> </span>
      </div>

      <form [formGroup]="userForm" (ngSubmit)="submitForm()">
        <div class="row">
          <div class="formGroup col-sm-6">
            <label>First Name <sup>*</sup> </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="firstName" />
            </mat-form-field>
            <div class="error" *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
              First Name is required.
            </div>
          </div>
          <div class="formGroup col-sm-6">
            <label>Last Name <sup>*</sup></label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="lastName" />
            </mat-form-field>
            <div class="error" *ngIf="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched">
              Last Name is required.
            </div>
          </div>
        </div>
        <div class="formGroup">
          <label>Email <sup>*</sup> </label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="email" />
          </mat-form-field>
          <div *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
            <div class="error" *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</div>
            <div class="error" *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</div>
          </div>
        </div>
        <div class="formGroup">
          <label>Experience Level <sup>*</sup></label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="experience" placeholder="Select Experience Level">
              <mat-option *ngFor="let level of experienceLevels" [value]="level.value">
                {{ level.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error" *ngIf="userForm.get('experience')?.invalid && userForm.get('experience')?.touched">
            Experience is required.
          </div>
        </div>
        <div class="formGroup">
          <label>Resume <sup>*</sup></label>
          <input type="file" (change)="onFileChange($event)" />
          <div class="error" *ngIf="userForm.get('resume')?.invalid && userForm.get('resume')?.touched">
            Resume is required.
          </div>
        </div>
        <div class="btn_row d-flex">
          <button mat-button class="cancel_btn" (click)="closeModal()">Cancel</button>
          <!-- <button mat-button class="apply_btn submit" type="submit">Submit Detail</button> -->
          <button mat-button class="apply_btn submit" type="submit">Submit Detail</button>
        </div>
      </form>
    </div>
  </div>

</div>
